import type { HTMLAttributes, ReactNode } from 'react';

export interface TabProps extends HTMLAttributes<HTMLDivElement> {
  name: string;
  label: string;
  adornment?: ReactNode;
  disabled?: boolean;
}

export default function Tab({
  name,
  label,
  adornment,
  disabled,
  ...props
}: TabProps) {
  return <div {...props} />;
}
